import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Box,
} from "@mui/material";
import { useState, useEffect } from "react";

import SiteIcons from "@/components/SiteIcons/SiteIcons";

function TemplateMapping({ data }) {
  const [tableRows, setTableRows] = useState(null);
  const [mapText, setMapText] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (data?.error) {
      setMapText(null);
      setLoading(false);
    } else if (data) {
      setMapText(data);
      setLoading(false);
    }
  }, [data]);

  useEffect(() => {
    if (mapText) {
      createTableRows(mapText);
    }
  }, [mapText]);

  const LookupTable = ({ columnNames, data }) => {
    if (!data || !columnNames) {
      return null;
    }

    return (
      <TableContainer>
        <Table aria-label="simple table">
          <TableHead>
            <TableRow>
              {columnNames.map((col) => (
                <TableCell key={col}>{col}</TableCell>
              ))}
            </TableRow>
          </TableHead>
          <TableBody>
            {data.map((row, index) => (
              <TableRow
                key={index}
                sx={{ "&:last-child td, &:last-child th": { border: 0 } }}
              >
                {row.map((cell) => (
                  <TableCell
                    key={cell}
                    component="th"
                    scope="row"
                    sx={{
                      border: "1px solid #dadada !important",
                      "&:last-child": {
                        backgroundColor: "#72a3d23b",
                      },
                    }}
                  >
                    {cell}
                  </TableCell>
                ))}
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    );
  };

  const createTableRows = (data) => {
    const lines = data.split("\n");
    lines.shift();

    const rows = lines.map((line) => {
      line = line.split("|");
      if (line[1].trim() !== "lookup") {
        return {
          column: line[2].trim(),
          adaField: line[0].trim(),
          formula: line[1].trim(),
          formulaData: null,
        };
      } else {
        // handle row with lookup table
        // get array of arrays and convert from JSON
        const lookupData = line[2].trim();
        const sliceHere = lookupData.indexOf("[");
        const arrays = lookupData.slice(sliceHere);
        const data = JSON.parse(arrays);

        // get column names, append OUTPUT to name last column header, convert to array
        let lookupColumnNames = lookupData.slice(0, sliceHere);
        lookupColumnNames += "OUTPUT";
        lookupColumnNames = lookupColumnNames.split(",");

        return {
          column: null, // column names are shown in the lookup table
          adaField: line[0].trim(),
          formula: line[1].trim(),
          lookupColumnNames,
          formulaData: data,
        };
      }
    });
    setTableRows(rows);
  };

  return (
    <Box sx={{ margin: "auto" }}>
      {loading ? (
        <Box sx={{ display: "flex", justifyContent: "center" }}>
          <SiteIcons
            iconstring="circular-loader"
            size="3rem"
            page="sitewide-loader"
          />
        </Box>
      ) : tableRows ? (
        <TableContainer sx={{ backgroundColor: "white" }}>
          <Table
            sx={{ minWidth: 650, maxWidth: "900px" }}
            aria-label="simple table"
          >
            <TableHead>
              <TableRow>
                <TableCell>Column Name</TableCell>
                <TableCell>Ada Field</TableCell>
                <TableCell>Formula</TableCell>
                <TableCell>Lookup Table</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {tableRows.map((row) => (
                <TableRow
                  key={row.column}
                  sx={{ "&:last-child td, &:last-child th": { border: 0 } }}
                >
                  <TableCell component="th" scope="row">
                    {row.column}
                  </TableCell>
                  <TableCell>{row.adaField}</TableCell>
                  <TableCell>{row.formula}</TableCell>
                  <TableCell>
                    <LookupTable
                      data={row.formulaData}
                      columnNames={row.lookupColumnNames}
                    />
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      ) : (
        <Box>Mapping not available</Box>
      )}
    </Box>
  );
}

export default TemplateMapping;
